import { Container, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useParams, useHistory } from "react-router-dom";
import { services } from "../services/api";
import GifLoader from "../components/ui/gifLoader";
import swal from "sweetalert";

export const VerificarDocumentoGlobal = () => {
  const [state, setState] = useState({});
  const [loadingPdf, setLoadingPdf] = useState(true);
  const [loader, setloader] = useState(false);

  const { lcaptura } = useParams();
  const history = useHistory();

  const colorUI = "#6f1d46";

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: colorUI,
    "&:hover": {
      backgroundColor: colorUI,
    },
  }));

  const ColorButtonSecond = styled(Button)(({ theme }) => ({
    color: colorUI,
    backgroundColor: "#ffc3d0",
    border: "none",
    "&:hover": {
      transform: "scale(1.005)",
      boxShadow: "3px 3px 6px 0px rgba(0, 0, 0, 0.2)",
    },
  }));

  const getDataDocument = async (lcaptura) => {
    setloader(true);
    let response = await services("GET", `verificador/linea/${lcaptura}`, null);

    const { data } = response;

    if (response.status === 200) {
      setState({
        ...state,
        data,
      });
    }
    if (response.status === 404) {
      swal({
        title: "Atención",
        text: "Línea de captura no encontrada",
        icon: "warning",
        button: "Aceptar",
      }).then(() => {
        history.replace("/");
      });
      document.querySelector(".swal-button--confirm").style.backgroundColor =
        colorUI;
      setState({ ...state, ready: false });
    }
    setloader(false);
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      if (!lcaptura) {
        history.replace("/");
        return;
      }
      getDataDocument(lcaptura);
    }

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {loader ? <GifLoader /> : null}

      {state.data ? (
        <Container maxWidth="md">
          <div className="container">
            {state?.data?.estatus === "01" ? (
              <div className="my-3">
                <div className="bg-green text-small text-green p-3">
                  <h5 className="fs-4">{state?.data?.mensaje}</h5>
                  Monto pagado: ${state?.data?.monto} <br />
                  Fecha de pago: {state?.data?.fechaVencimiento} <br />
                </div>
              </div>
            ) : (
              <div className="my-3">
                <div className="bg-red text-small p-3">
                  <h5 className="fs-4">{state?.data?.mensaje}</h5>
                  {state?.data?.estatus === "03" && (
                    <div className="bg-danger text-white p-2 mb-2 rounded">
                      FECHA DE VENCIMIENTO EXPIRADA
                    </div>
                  )}
                  {state?.data?.estatus === "02" && (
                    <>
                      Descarga tu formato de pago o realiza el pago en línea
                      <br />
                    </>
                  )}
                  Línea de captura: {state?.data?.lineaCaptura} <br />
                </div>
              </div>
            )}
            <div className="pt-2 border-bottom--guinda text-big mb-2 text-bold">
              {state?.data?.estatus === "01"
                ? "Recibo de pago"
                : state?.data?.estatus === "03"
                ? "FECHA DE VENCIMIENTO EXPIRADA"
                : "Formato de pago"}
            </div>

            {loadingPdf && (
              <div className="d-flex justify-content-center align-items-center py-3">
                <p>Cargando PDF...</p>
              </div>
            )}

            <div className="d-flex justify-content-center aling-items-center py-3 vh-100">
              <object
                data={state?.data?.liga_pdf}
                type="application/pdf"
                height="100%"
                width="100%"
                aria-label="formato"
                onLoad={() => setLoadingPdf(false)}
              ></object>
            </div>
          </div>
        </Container>
      ) : null}
    </>
  );
};
